module.exports = __webpack_public_path__ + "img/lk-mode-mobile-grey.95a925c4.svg";